import gql from 'graphql-tag';

export * from './types';

const QUOTATION_FIELDS = `
  currency
  premium_frequency
  basic_premium
  non_insurance_premium
  premium_loading
  premium_loadings
  discount
  discount_config
  levy
  total_premium
  pre_levy_premium
`;

const PROMOTION_VALIDATION_FIELDS = `
  promo_code
  message
  effective_to
`;

const GET_SUM_ASSURED_RANGE_FIELDS = `
  product
  min_issue_age
  max_issue_age
  min_sum_assured
  max_sum_assured
  create_date
`;

export const RETRIEVE_QUOTATION = gql`
  query Quotation(
    $productId: String!,
    $sumAssured: Int,
    $gender: String,
    $smoker: String,
    $currency: String,
    $frequency: String,
    $dateOfBirth: String,
    $age: Int,
    $couponCode: String,
  ) {
    quotation(
      product_id: $productId,
      sum_assured: $sumAssured,
      gender: $gender,
      smoker: $smoker,
      currency: $currency,
      frequency: $frequency,
      date_of_birth: $dateOfBirth,
      age: $age,
      coupon_code: $couponCode
    )
    @rest(type: "Quotation", path: "/quotation?{args}") {
      __typename
      ${QUOTATION_FIELDS}
    }
  }
`;

export const PROMOTION_VALIDATION = gql`
  mutation PromotionValidate($productId: PRODUCT_ID, $promoCode: PROMO_CODE) {
    promotion(product_id: $productId, promo_code: $promoCode)
      @rest(type: "promotion" path: "/promotion/validate?{args}") {
      __typename
      ${PROMOTION_VALIDATION_FIELDS}
    }
  }
`;

export const GET_SUM_ASSURED_RANGE = gql`
  query GetSumAssuredRange($productId: PRODUCT_ID) {
    sumAssuredRange(product_id: $productId)
      @rest(type: "Range", path: "/product/{args.product_id}/sum-assured-ranges") {
      __typename
      ${GET_SUM_ASSURED_RANGE_FIELDS}
    }
  }
`;

export const LIST_PRODUCT_GROUP = gql`
  query ListProductGroup(
    $type: String
    $fromBundleType: String
    $variableAttribute: String
  ) {
    productGroups(
      type: $type
      from_bundle_type: $fromBundleType
      variable_attribute: $variableAttribute
    ) @rest(type: "[ProductGroup]", path: "/product/group?{args}") {
      _typename
      elements
      group_ids
      variables
    }
  }
`;

// old api
export const LIST_PRODUCT = gql`
  query ListProduct($type: String) {
    products(type: $type) @rest(type: "[Product]", path: "/product?{args}") {
      _typename
      allow_flexible_selection
      annual_limit
      code
      type
      headline
      short_name
      lifetime_limit
      spec
      min_issue_age_value
      min_issue_age_unit
      max_issue_age_value
      max_issue_age_unit
      plan_details_url
    }
  }
`;
